/**
 * Created by Sasha on 7/25/2018.
 */
import moment from 'moment';
import {Injectable} from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from '@angular/router';
import { Observable , BehaviorSubject} from 'rxjs';
import { AppConfig } from '../../app.config';
@Injectable()
export class ConfessionService  {
  confessions: any[];
  onConfessionChanged: BehaviorSubject<any> = new BehaviorSubject({});
  constructor (private http: HttpClient, private api: AppConfig) {

  }
  /**
   * Resolve
   * @param {ActivatedRouteSnapshot} route
   * @param {RouterStateSnapshot} state
   * @returns {Observable<any> | Promise<any> | any}
   */
  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> | Promise<any> | any
  {

    return new Promise<void>((resolve, reject) => {

      Promise.all([
        this.getConfessions()
      ]).then(
        () => {
          resolve();
        },
        reject
      );
    });
  }

  getConfessions () {
    return new Promise((resolve, reject) => {
      this.http.get(this.api.baseUrl + '/confession/confessions'  , this.api.jsonTokenHeaders)
        .subscribe((response: any) => {
          this.confessions = response;
          this.onConfessionChanged.next(this.confessions);
          resolve(response);
        }, reject);
    });

  }

  getConfessionById(id) {
    return this.http.get(this.api.baseUrl + '/confession/confession?id=' + id , this.api.jsonTokenHeaders);
  }

  deleteConfession(id) {
    return this.http.delete(this.api.baseUrl + '/confession/deleteConfession?id=' + id , this.api.jsonTokenHeaders);
  }

  addConfession(data) {
    return this.http.post(this.api.baseUrl + '/confession/addConfession' , data , this.api.formDataHeaders);
  }
}
